import { useState, useCallback, useEffect } from 'react';
import { useFormik } from 'formik';
import { useHistory } from 'react-router-dom';

import { createOrUpdateAllowance, getAllowanceById } from 'api/attendAllowance';
import AttendAllowanceDomain from 'domain/master/labor/attendAllowance';
import useToastNotification from 'hooks/useToastNotification';

/**
 * 手当マスタ 登録・編集（C3_RESDUC-1877）
 * 手本: components/organismos/Executive/ExecutiveAddForm/hooks.ts
 */
export const useAttendAllowanceAddForm = (allowanceId?: string) => {
  const isEdit = !!allowanceId;
  const history = useHistory();

  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const { successNotification, errorNotification } = useToastNotification();

  const onSubmit = async (values: AttendAllowanceDomain) => {
    if (!values.allowanceCode) {
      errorNotification('手当コードを入力してください。');
      return false;
    }
    if (!values.allowanceName) {
      errorNotification('手当名を入力してください。');
      return false;
    }
    if (!values.dispMessage) {
      errorNotification('表示メッセージを入力してください。');
      return false;
    }
    if (/^ +$/.test(values.allowanceCode)) {
      errorNotification('コードに半角、全角スペースは入力できません。');
      return false;
    }

    if (!confirmModalOpen) {
      setConfirmModalOpen(true);
      return false;
    }

    try {
      const response = await createOrUpdateAllowance(values.getRawData());
      if (!response.errors) {
        setConfirmModalOpen(false);
        successNotification(isEdit ? '更新しました。' : '登録しました。');
        // 保存できたら一覧へ戻る（一覧は表示のたびに再取得するので登録内容が反映される）
        history.push('/masterAttendAllowance');
      }
    } catch (error) {
      setConfirmModalOpen(false);
      if (error.response && error.response.data && error.response.data.errors) {
        const listErr = error.response.data.errors;
        let stringErr = '';
        listErr.map((element: any) => {
          stringErr += `${element.defaultMessage} \n`;
          return stringErr;
        });
        errorNotification(stringErr);
      } else {
        errorNotification('サーバー側でエラーが発生しました。');
        throw error;
      }
    }
    return false;
  };

  const formik = useFormik({
    initialValues: AttendAllowanceDomain.generateInitial(),
    validationSchema: false,
    onSubmit,
  });

  useEffect(() => {
    if (allowanceId) {
      getAllowanceById(allowanceId).then((response: any) => {
        if (response) {
          formik.setValues(new AttendAllowanceDomain(response));
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allowanceId]);

  const closeConfirmModal = useCallback(() => {
    setConfirmModalOpen(false);
  }, []);

  return {
    formik,
    confirmModalOpen,
    closeConfirmModal,
  };
};

export default {
  useAttendAllowanceAddForm,
};
